import { clone, uniq } from 'lodash';
import { Component, Vue} from 'nuxt-property-decorator';
import {mapGetters, mapState} from 'vuex';
import { ICity } from '~/types/city';
import { IMainLocation } from '~/types/region';

@Component({
    components: {
        loader: require('~/components/common/loader-block').default,
        shadedContainer: require('~/components/common/shaded-container').default,
    },
    computed: {
        ...mapState(['region']),
        ...mapState('data', ['cityList']),
    },
})
export default class CitySelectorComponent extends Vue {

    public searchText: string = '';
    public region: IMainLocation;
    public cityList: ICity[];

    private topCityCodes = new Set([53236, 53238]);

    public created() {
        this.$store.dispatch('data/GetCityList');
    }

    public async setCity(city: number) {
        await this.$store.dispatch('ChangeCity', city);

        this.$emit('close');
    }

    get topCities(): ICity[] {
        if (!this.cityList) {
            return [];
        }

        const cityList = this.cityList
            .filter((el) => this.topCityCodes.has(el.id))
            .sort((a, b) => a.name.localeCompare(b.name));

        if (!this.topCityCodes.has(this.region.city.id)) {
            const foundCity = this.cityList.find((el) => el.id === this.region.city.id);
            if (foundCity) {
                cityList.unshift(foundCity);
            }
        }

        return cityList;
    }

    get defaultDisplayList() {
            const cityList = this.cityList
            .filter((el) => el.top && !this.topCityCodes.has(el.id) && el.id !== this.region.city.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((el) => clone(el));

        let lastLetter: string | null = null;

        cityList.forEach((el) => {
            el.highlight = el.name[0] !== lastLetter;
            lastLetter = el.name[0]!;
        });

        return cityList;
    }

    get displayList(): ICity[] {

        if (!this.cityList) {
            return [];
        }

        const query = this.searchText.trim().toLocaleLowerCase();

        if (query.length) {

            // хуйня, да
            return uniq([
                ...this.cityList.filter((el) => el.name.toLowerCase().startsWith(query) && el.top).sort((a, b) => a.name.localeCompare(b.name)),
                ...this.cityList.filter((el) => el.name.toLowerCase().startsWith(query)).sort((a, b) => a.name.localeCompare(b.name)),
                ...this.cityList.filter((el) => el.region && el.region.toLowerCase().includes(query)).sort((a, b) => a.name.localeCompare(b.name)),
                ...this.cityList.filter((el) => el.name.toLowerCase().includes(query)).sort((a, b) => a.name.localeCompare(b.name)),
                ...this.cityList.filter((el) => el.region && el.region.toLowerCase().startsWith(query)).sort((a, b) => a.name.localeCompare(b.name)),
            ])
        }

        return this.defaultDisplayList;
    }
}
